import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

/**
 * IdP-based OAuth2/OIDC configuration used when environment.AUTH_MODE === 'IDP'.
 */
function getAppOrigin(): string {
  const locationRef = (globalThis as any).location;
  return locationRef?.origin ?? '';
}

const appOrigin = getAppOrigin();

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.ISSUER,
  redirectUri: environment.REDIRECT_URI,
  clientId: environment.CLIENT_ID,
  responseType: environment.RESPONSE_TYPE,
  postLogoutRedirectUri: environment.REDIRECT_URI,
  scope: environment.SCOPE,
  strictDiscoveryDocumentValidation: environment.strictDiscoveryDocumentValidation,
  // showDebugInformation: !environment.production,
  sessionChecksEnabled: false,
  silentRefreshRedirectUri: `${appOrigin}?silent-refresh=true`,
  useSilentRefresh: true,
  timeoutFactor: environment.TIMEOUT_FACTOR,
};
